import { Card, Button } from '@nearst/ui';
import { StepNumber } from './StepNumber';
import styles from '../UnifyOnboarding.module.scss';

export const GoogleBusinessProfile = ({
	isActive,
	isCompleted,
	businessDetailsCompleted,
	gbpLoading,
	pollingForGBPConnection,
	gbpError,
	currentShop,
	onConnect
}) => {
	return (
		<Card className={styles.stepCard}>
			<div className={styles.stepHeader}>
				<StepNumber number={2} isActive={isActive} isCompleted={isCompleted} />
				<h3 className={styles.stepTitle}>Link your Google Business Profile account</h3>
			</div>

			{!isCompleted ? (
				<div className={styles.stepContent}>
					{pollingForGBPConnection && (
						<div className={styles.pollingMessage}>
							<p>Verifying Google Business Profile connection...</p>
							<p className={styles.helperText}>
								This should only take a moment. We&apos;re confirming your connection.
							</p>
						</div>
					)}

					{gbpError && (
						<div className={styles.error}>
							{gbpError}
						</div>
					)}

					<p className={styles.helperText}>
						We use this to verify your shop and list your products on Google.
					</p>

					<Button
						primary
					className={styles.submitButton}
						onClick={onConnect}
						disabled={!businessDetailsCompleted || gbpLoading || pollingForGBPConnection}
					>
						{gbpLoading || pollingForGBPConnection ? 'Connecting...' : 'Connect Google Business Profile'}
					</Button>
				</div>
			) : (
				<div className={styles.stepContent}>
					<div className={styles.completedInfo}>
						<div>
							<p>
								<strong>Google Business Profile connected</strong>
							</p>
							<p className={styles.helperText}>
								Connected as: {currentShop?.gmbConnection?.email || 'N/A'}
							</p>
							<p className={styles.helperText}>
								Location: {currentShop?.name || 'N/A'}
							</p>
						</div>
					</div>
				</div>
			)}
		</Card>
	);
};
